import LocalizedStrings from 'react-localization';
import { withCommon } from '../../services/common.translations';

const strings = new LocalizedStrings({
  en: {
    notFound: {
      title: "Page Not Found",
      message: "We're sorry- that page doesn't seem to be here! Please check the URL is correct."
    }
  }
});

export default withCommon<typeof strings>(strings);
